(function IIFE() {
    'use strict';

    /////////////////////////////

    function DirectoryEntryUserFactory($resource, Config) {
        'ngInject';

        return $resource(Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/directory/entry/user/:methodKey', {}, {
            'delete': {
                isArray: false,
                method: 'DELETE',
                params: {
                    methodKey: 'delete',
                },
            },
            'save': {
                isArray: false,
                method: 'POST',
                params: {
                    methodKey: 'save',
                },
            },
        });
    }

    /////////////////////////////

    angular.module('Factories').factory('DirectoryEntryUserFactory', DirectoryEntryUserFactory);
})();
